export default __webpack_public_path__ + "static/media/sm.de55d2a9.svg";